export const clients = [
  { name: "AbriLivre", since: 2019 },
  { name: "Pimentel, Helito & Razuk Sociedade de Advogados", since: 2017 },
  { name: "Zingales Advogados", since: 2012 },
  { name: "MT Performance", since: 2016 },
  { name: "Ricardo Calil Sociedade de Advogados", since: 2016 },
];
